import LambdaApiService from '@/services/apiService/lambda';
import NiotaClassicApiService from '@/services/niotaClassicApiService';
import formMixin from '../../formMixin';
import parserTypesMixin from './typesMixin';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
export default {
  name: 'NiotaClassicDevicetypesPacketParserPayloadTest',
  mixins: [formMixin, parserTypesMixin],
  props: {
    parserConfig: {
      type: Object,
      required: true
    },
    parserType: {
      type: String,
      required: true
    },
    accountId: {
      type: Number,
      required: true
    },
    customTestFunction: {
      type: Function,
      requirded: false,
      default: null
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      parserTestFormIsValid: false,
      parserTestData: {
        loraFramePort: 1,
        payloadType: 'HEX'
      },
      isParsing: false
    };
  },
  computed: {
    payloadHexRule() {
      const isJsonPayload = v => {
        if (!v) {
          return false;
        }
        try {
          const parsed = JSON.parse(v);
          // do not allow simple strings or numbers
          return isArray(parsed) || isObject(parsed);
        } catch (_) {
          return false;
        }
      };
      return this.requiredRule.concat([v => this.parserTestData.payloadType === 'HEX' && this.isHexPayload(v) || this.parserTestData.payloadType === 'JSON' && isJsonPayload(v) || `Must be valid ${this.parserTestData.payloadType === 'HEX' ? 'Hex-payload' : 'json-array/object'}`]);
    }
  },
  methods: {
    isHexPayload(v) {
      return !!v && v.length % 2 === 0 && /^[a-fA-F0-9]+$/.exec(v) !== null;
    },
    validateForm() {
      this.$refs['parserTestForm'].validate();
    },
    async testClassicDeviceTypeParser(payload, meta) {
      let hasError = false;
      try {
        // https://gitlab.com/digimondo-code/niota-web/-/blob/master/src/services/payloadParser.ts
        let res = {
          data: {}
        };
        const accountData = await NiotaClassicApiService.accountsGet(this.accountId);
        const apiKey = get(accountData, 'data.account.data.realTimeApiKey');
        if (apiKey) {
          res = await NiotaClassicApiService.deviceTypesParsePayload({
            parseConfig: {
              parser: {
                config: this.parserConfig,
                type: this.parserType
              },
              payload,
              meta
            },
            api_key: apiKey
          });
        } else {
          // TODO: error-message, can this happen?
          console.error('Account does not seem to have an API-key', this.accountId, accountData);
        }
        const parsedRes = res.data;
        hasError = get(parsedRes, 'result.body.error');
        if (!hasError) {
          this.parserTestData.response = get(parsedRes, 'result.body.parsed');
          this.parserTestData = cloneDeep(this.parserTestData);
        }
      } catch (error) {
        console.error('Test-payload parsing failed', get(error, 'response.data.err', error));
        hasError = get(error, 'response.data.err', error);
      }
      return hasError;
    },
    async testParser() {
      try {
        this.isParsing = true;
        const properPayload = this.isHexPayload(this.parserTestData.payload) ? this.parserTestData.payload : JSON.parse(this.parserTestData.payload);
        const meta = {
          lora: {
            fport: parseInt(this.parserTestData.loraFramePort)
          },
          device_id: -1,
          device_type_id: -1
        };
        let hasError = false;
        if (typeof this.customTestFunction === 'function') {
          try {
            const parseTestResult = await this.customTestFunction(properPayload, meta);
            this.parserTestData.response = parseTestResult.result;
            this.parserTestData = cloneDeep(this.parserTestData);
          } catch (err) {
            hasError = err.response.data.error;
          }
        } else {
          hasError = await this.testClassicDeviceTypeParser(properPayload, meta);
        }
        if (!hasError) {
          return;
        }

        // if the parser is a Javascript function parser and there was an error,
        // run it again through the lambda service evaluator to catch possibly syntax errors
        if (this.parserType === 'function' && get(this.parserConfig, 'scriptType') === 'javascript') {
          let syntaxError = null;
          await LambdaApiService.evaluateScript({
            script: get(this.parserConfig, 'custom_function_js'),
            scriptParams: [this.parserTestData.payload, {
              lora: {
                fport: parseInt(this.parserTestData.loraFramePort)
              },
              device_id: -1,
              device_type_id: -1
            }]
          }).then(res => {
            syntaxError = get(res, 'syntaxError') || get(res, 'error');
          }).catch(error => {
            console.error(error);
          });
          if (syntaxError) {
            hasError = syntaxError;
          }
        }
        this.parserTestData.response = hasError;
        this.parserTestData = cloneDeep(this.parserTestData);
      } finally {
        this.isParsing = false;
      }
    }
  }
};